module.exports = __webpack_public_path__ + "static/media/due-port08.c96c00e9.jpg";